import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useQuerySlackIntegrationConfig } from '../../models/useQuerySlackIntegrationConfig'

export const useGetSlackIntegrationConfigPresenter = (): {
  isIntegrated: boolean | null
  oauthUrl: string
  isLoading: boolean
  error: string | null
} => {
  const { integrationStatus, isLoading, error } =
    useQuerySlackIntegrationConfig()

  const isIntegrated = integrationStatus?.isSlackIntegrated ?? null
  const oauthUrl = integrationStatus?.slackOAuthUrl ?? ''
  const errorMessage = error
    ? getMessageFromError(error) || 'An error occurred'
    : null

  return {
    isIntegrated,
    oauthUrl,
    isLoading,
    error: errorMessage,
  }
}
